/**
 * Single-tab guard. Two widgets must never answer for the same agent, so only one tab may hold
 * the softphone. The newest tab to claim wins and every older holder is told it lost the claim.
 */
export const SOFTPHONE_TAB_CHANNEL = 'ringbax-softphone-tab-lock'

const CLAIM = 'claim'
const RELEASE = 'release'

export class SoftphoneTabLock {
  constructor(channelName = SOFTPHONE_TAB_CHANNEL) {
    this.tabId = `${Date.now()}-${Math.random().toString(36).slice(2)}`
    this.isHeld = false
    this.onLost = null

    // Safari <15.4 and some embedded webviews have no BroadcastChannel. Degrade to a
    // no-op lock (single-tab enforcement is unavailable) rather than blocking the feature.
    this.isSupported = typeof BroadcastChannel !== 'undefined'
    this.channel = this.isSupported ? new BroadcastChannel(channelName) : null

    if (this.channel) {
      this.channel.onmessage = event => this._handleMessage(event?.data)
    }
  }

  claim() {
    this.isHeld = true

    this._post({ type: CLAIM, tabId: this.tabId })
  }

  release() {
    if (!this.isHeld) {
      return
    }

    this.isHeld = false

    this._post({ type: RELEASE, tabId: this.tabId })
  }

  destroy() {
    this.release()

    this.onLost = null

    if (this.channel) {
      this.channel.onmessage = null
      this.channel.close()
      this.channel = null
    }
  }

  _post(message) {
    if (!this.channel) {
      return
    }

    this.channel.postMessage(message)
  }

  _handleMessage(message) {
    if (!message || message.tabId === this.tabId) {
      return
    }

    if (message.type === CLAIM && this.isHeld) {
      this.isHeld = false

      if (this.onLost) {
        this.onLost()
      }
    }
  }
}

export default SoftphoneTabLock
